import { render, staticRenderFns } from "./TeacherCard.vue?vue&type=template&id=06ce676f&scoped=true"
import script from "./TeacherCard.vue?vue&type=script&lang=js"
export * from "./TeacherCard.vue?vue&type=script&lang=js"
import style0 from "./TeacherCard.vue?vue&type=style&index=0&id=06ce676f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ce676f",
  null
  
)

export default component.exports